export default "__VITE_ASSET__D4jLa$ny__"